import React from "react";

const Store2 = (props) => (

  <div className="sideNavSection">
    <div className="feature">
      <h3>Out now on Dream Chimney</h3>
      {/* <p style={{ fontSize: 14 }}> Personal System 個人システム "Distant Paradise"</p>
  <a href="https://dreamchimney.bandcamp.com/album/distant-paradise" target="_blank">
    <img src="https://www.dreamchimney.com/releases/DC015/DC015_tape_bg_300.png" className="img-responsive center-block" alt="Distant Paradise" />
    <div className="featureTextFooter">
      <strong>Available now on Digital &amp; Cassette &raquo;</strong>
    </div>
  </a> */}
      <p style={{ fontSize: 15, marginTop: 4, marginBottom: 10 }}><strong>Personal System 個人システム "Liminal City '87"</strong></p>
      <p style={{ fontSize: 14 }}>an imaginary soundtrack of an obsessed journalist investigating mysterious disappearances in liminal spaces in a blend of smooth jazz, vaporwave and new-age ambient.</p>
      <a href="https://dreamchimney.bandcamp.com/album/liminal-city-87-live-in-tokyo" target="_blank" onClick={() => window.gtag('event', 'totd_click', { eventLabel: `Tracks Right Nav: Personal System` })}>
        <img src="https://f4.bcbits.com/img/a3211313890_2.jpg" className="img-responsive center-block" alt="Personal System 個人システム" />
        <div className="featureTextFooter">
          <strong>Available now &raquo;</strong>
        </div>
      </a>
    </div>
  </div>
);

export default Store2;
